import ApexProvider from "./ApexProvider";
import FetchSettings from "../../interfaces/FetchSettings";

export default class ApexJiraProvider extends ApexProvider {
  public async getCategoryJira(categoryId: number): Promise<Response> {
    const settings: FetchSettings = {
      method: "GET",
    };
    try {
      const response: Response = await this.request(
        this.baseUrl + "settings/category/" + categoryId + "/jira",
        settings,
        true
      );
      return response;
    } catch (error) {
      console.error(error);
    }
  }

  public async getDiscussionEpic(discussionId: number): Promise<Response> {
    const settings: FetchSettings = {
      method: "GET",
    };
    try {
      const response: Response = await this.request(
        this.baseUrl + "idea/" + discussionId + "/jira",
        settings,
        true
      );
      return response;
    } catch (error) {
      console.error(error);
    }
  }
}
